export function toHoursAndMinutes(totalMinutes) {
  return new Date(totalMinutes * 1000).toISOString().slice(11, 19);
}
